
// File: src/components/management/UserAvailability/UnavailableDates.jsx

import React from "react";

export default function UnavailableDates({
  allUsers,
  selectedUAUser,
  setSelectedUAUser,
  uaDate,
  setUADate,
  allUnavailable,
  handleAddUnavailable,
  handleDeleteUnavailable,
  loadingUnavailable,
}) {
  return (
    <section className="ua-unavail-section">
      <h2>Unavailable Dates</h2>
      {loadingUnavailable && <div className="ua-loading">Loading…</div>}

      <div className="ua-unavail-form">
        <div className="ua-form-group">
          <label htmlFor="ua-user-select">User:</label>
          <select
            id="ua-user-select"
            value={selectedUAUser}
            onChange={(e) => setSelectedUAUser(e.target.value)}
          >
            <option value="">-- Choose user --</option>
            {allUsers.map((u) => (
              <option key={u.USER_ID} value={u.USER_ID}>
                {u.USER_NAME} {u.USER_SURNAME} ({u.COMPANY_NAME})
              </option>
            ))}
          </select>
        </div>
        <div className="ua-form-group">
          <label htmlFor="ua-date-input">Date:</label>
          <input
            type="date"
            id="ua-date-input"
            value={uaDate}
            onChange={(e) => setUADate(e.target.value)}
          />
        </div>
        <div className="ua-form-group">
          <button
            className="ua-btn ua-btn-add-unavail"
            onClick={handleAddUnavailable}
            disabled={loadingUnavailable}
          >
            {loadingUnavailable ? "Adding…" : "Add Unavailable Date"}
          </button>
        </div>
      </div>

      <div className="ua-unavail-table-wrapper">
        <table className="ua-unavail-table">
          <thead>
            <tr>
              <th>User</th>
              <th>Date</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {allUnavailable.map((rec) => (
              <tr key={`${rec.user_id}__${rec.unavailable_date}`}>
                <td data-label="User">
                  {rec.USER_NAME} {rec.USER_SURNAME} ({rec.COMPANY_NAME})
                </td>
                <td data-label="Date">{rec.unavailable_date}</td>
                <td data-label="Delete">
                  <button
                    className="ua-btn ua-btn-delete-unavail"
                    onClick={() =>
                      handleDeleteUnavailable(rec.user_id, rec.unavailable_date)
                    }
                    disabled={loadingUnavailable}
                  >
                    ✖
                  </button>
                </td>
              </tr>
            ))}
            {allUnavailable.length === 0 && (
              <tr>
                <td colSpan="3" className="ua-no-data">
                  No unavailable dates added.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
